import { fullComparator } from '../../filtre-investisseur-helper';
import { AgeFiltreCustomBuilder, FiltreBuilder } from '../filtre-builder.model';

export function getIdentiteBuilders(): FiltreBuilder[] {
  return [
    new AgeFiltreCustomBuilder(
      'IDENTITE',
      'PHYSIQUE_AGE',
      'atlasInvestisseur.investisseurPersonnePhysiques.some.personnePhysique.dateNaissance',
      fullComparator,
      'Age',
      undefined,
      2
    ),
  ];
}
